import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Container,
    Row,
    Col } from 'reactstrap';
import { Button } from '../Forms';
import { connect } from 'react-redux';
import { doSentLinkVerificationEmail } from '../../actions/authAction';

class ModalAterRegister extends Component{
    constructor(props){
        super(props);
        this._onSentEmail = this._onSentEmail.bind(this);
    }

    _onSentEmail(){
        this.props.submit();
        setTimeout(()=>{
            if(this.props.isOpen===true)
                this.props.onToggle();
            this.props.onSuccess();
        },300)
    }

    render(){
        return(
            <Modal isOpen={this.props.isOpen} toggle={this.props.onToggle} className="kick-modal modal-not-verified">
                <ModalHeader toggle={this.props.onToggle}>Selamat bergabung di Kick Avenue</ModalHeader>
                <ModalBody>
                    <Container>
                        <h5>{this.props.email}</h5>
                        <p>
                            Harap cek <b>inbox/junk/spam Anda dari no-reply@kickavenue.com</b> dan klik link <h5 style={{ margin: 0 }}>VERIFIKASI</h5> email yang berada di dalamnya.
                            Sesudah itu mohon logout dan login kembali untuk melanjutkan.<br/><br/>
                        </p>
                    </Container>
                </ModalBody>
            </Modal>
        )
    }
}

const mapStateToProps = ({dataAuth:{ userSentLinkEmailVerify }})=>({
    data : userSentLinkEmailVerify
})

const mapDispatchToProps = dispatch =>({
    submit : ()=> dispatch(doSentLinkVerificationEmail())
})

export default connect(mapStateToProps,mapDispatchToProps)(ModalAterRegister);
